import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core/";
import Button from '@material-ui/core/Button';
import "../Styles/global/loader.scss";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > * + *": {
      marginLeft: theme.spacing(2),
    },
  },
}));

export default function Loader(props) {
  const classes = useStyles();
  if (props.error) {
    return (
      <div className="error-layout">
        <p className="error-message">
          Seems your network connection is bad today
        </p>
        <Button size="medium" variant="outlined" color="primary" onClick={props.retry}>Retry</Button>
        <p>Or pull to refresh</p>
      </div>
    );
  } else if (props.pastDelay) {
    return (
      <div
        className={classes.root}
        style={{
          height: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </div>
    );
  } else {
    return null;
  }
}
